import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '../shared/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { ManagersNotesComponent } from './components/managers-notes/managers-notes.component';

@NgModule({
  declarations: [
    ManagersNotesComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    TranslateModule
  ],
  exports: [
    ManagersNotesComponent
  ]
})
export class ManagersNotesModule { }
